import { render, staticRenderFns } from "./PopsManageFolderClinic.vue?vue&type=template&id=0d21f294"
import script from "./PopsManageFolderClinic.vue?vue&type=script&lang=js"
export * from "./PopsManageFolderClinic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports